export default __webpack_public_path__ + "static/media/chest_fly_end.3d86cb9e.svg";